import { render, staticRenderFns } from "./PasswordRepair_Setup.vue?vue&type=template&id=716c36eb&scoped=true"
import script from "./PasswordRepair_Setup.vue?vue&type=script&lang=ts"
export * from "./PasswordRepair_Setup.vue?vue&type=script&lang=ts"
import style0 from "./PasswordRepair_Setup.vue?vue&type=style&index=0&id=716c36eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c36eb",
  null
  
)

export default component.exports